import { Col, Divider, Form, Row, Spin } from 'antd';
import { useEffect, useMemo, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { setAppLoader } from '../../../../../../redux/common/CommonActions';
import useShipmentEditPermission from '../../../../../../redux/hooks/useShipmentEditPermission';
import {
  getCustomerRoutingSettingsInProgress,
  shipmentAddBidderInProgress,
} from '../../../../../../redux/shipment/ShipmentActions';
import { routeFileSelector } from '../../../../../../utilz/i18n';
import Button from '../../../../../components/Buttons/Button';
import FormCheckBox from '../../../../../components/Inputs/FormCheckBox';
import FormInput from '../../../../../components/Inputs/FormInput';
import HiddenFormInput from '../../../../../components/Inputs/HiddenFormInput';
import PrimaryLabel from '../../../../../components/Labels/PrimaryLabel';
import SportBidRouting from './SportBidRouting';

const AddBidderForm = ({ handleSpotBidSuccess, setAddBidderFormVisible }) => {
  const dispatch = useDispatch();
  const { pathname: activeTab } = useLocation();
  const namespace = useMemo(() => routeFileSelector(activeTab), [activeTab]);
  const { t } = useTranslation([namespace, 'translation']);
  const [selectedProviders, setSelectedProviders] = useState([]);
  const { shipmentDetails, customerRoutingsSettings } = useSelector((state) => state.shipment);
  const { selectedCompany } = useSelector((state) => state.auth);

  const spotBidButtonDisabled = useMemo(() => selectedProviders.length === 0, [selectedProviders]);

  const [form] = Form.useForm();

  const handleSelectedSpotProviders = (data) => {
    setSelectedProviders(data);
  };
  const handleSubmit = (data) => {
    dispatch(setAppLoader(true));
    const payload = {};
    payload.shipmentKey = shipmentDetails.data?.shipmentKey;
    payload.isReset = String(Number(Boolean(data.isReset)));
    payload.isSendMail = Number(!data.isSendMail);
    payload.spotBidCarrierEmailList = selectedProviders.map((row) => ({
      carrierKey: row.carrierKey,
      emailAddress: row.tenderEmailAddress,
    }));

    payload.callBackFun = () => {
      handleSpotBidSuccess();
    };
    dispatch(shipmentAddBidderInProgress(payload));
  };

  useEffect(() => {
    if (!customerRoutingsSettings?.success && selectedCompany?.companyId) {
      dispatch(
        getCustomerRoutingSettingsInProgress({
          Customerkey: selectedCompany?.companyId,
        }),
      );
    }
  }, [customerRoutingsSettings?.success, selectedCompany]);

  useEffect(() => {
    if (customerRoutingsSettings?.success) {
      form.setFieldsValue({
        adminEmail: customerRoutingsSettings?.data?.adminEmail,
      });
    }
  }, [customerRoutingsSettings?.success]);

  const hasEditPermission = useShipmentEditPermission();
  const submitButtonRef = useRef(null);

  return (
    <Form
      onFinish={handleSubmit}
      form={form}
      className="h-100 d-flex flex-direction-column"
      initialValues={{ routingType: 0 }}
    >
      <div className="">
        <Row className="" gutter={15} align="middle">
          <Col sm={24} md={6}>
            <Spin size="small" spinning={customerRoutingsSettings?.progressing}>
              <FormInput
                label={t('translation:shipmentAdd.rateShopDetails.adminEmail')}
                editMode={false}
                name="adminEmail"
                margin="m-0"
              />
            </Spin>
          </Col>
          <Col sm={24} md={6}>
            <FormCheckBox
              checkBoxClass="normal-checkbox"
              label={t('translation:shipmentAdd.spotBid.doNotSendEmail')}
              name="isSendMail"
              className="m-0"
            />
          </Col>
          <Col sm={24} md={6}>
            <FormCheckBox
              checkBoxClass="normal-checkbox"
              label={t('translation:shipmentAdd.spotBid.resetSpotBid')}
              name="isReset"
              className="m-0"
            />
          </Col>
        </Row>
      </div>
      <Divider className="my-15" />
      <Row>
        <Col>
          <PrimaryLabel className=" f-18">{t('translation:shipmentAdd.spotBid.routingSpotBidList')}</PrimaryLabel>
        </Col>
      </Row>
      <Divider className="my-15" />
      <div className="overflow-hidden h-100">
        <SportBidRouting handleSelectedSpotProviders={handleSelectedSpotProviders} />
      </div>
      <div
        style={{
          height: submitButtonRef?.current?.clientHeight ? submitButtonRef?.current?.clientHeight : 0,
        }}
      />
      <Row justify="end" className="submit-spot-bid-button-container" ref={submitButtonRef} gutter={15}>
        <Col>
          <Button disabled={spotBidButtonDisabled || !hasEditPermission} variant="success" buttonType="submit">
            {t('translation:shipmentAdd.spotBid.addBidder')}
          </Button>
        </Col>
        <Col>
          <Button variant="danger" onClick={() => setAddBidderFormVisible(false)}>
            Close
          </Button>
        </Col>
      </Row>
      <HiddenFormInput name="routingType" />
    </Form>
  );
};
export default AddBidderForm;
